import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";
import { InformationCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

interface ChangeTemplateWarningModalProps {
  opened: boolean;
  onClose: () => void;
  onContinue: () => void;
  isPending: boolean;
}

export const ChangeTemplateWarningModal = ({
  opened,
  onClose,
  onContinue,
  isPending
}: ChangeTemplateWarningModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[421px] w-full p-6"
    >
      <div className="flex flex-col items-center text-center">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-alpha-40 mb-6">
          <HugeiconsIcon
            icon={InformationCircleIcon}
            size={32}
            className="text-content-200"
          />
        </div>

        {/* This block use leading-8 to match designs */}
        <h2 className="w-full max-w-[300px] text-xl leading-8 font-bold text-content-1000 mb-2">
          Screening results and services may change
        </h2>

        <p className="text-sm font-medium text-content-400 mb-6">
          Updating the template version may result in additional services being
          ran that were not enabled on the initial version. Any additional
          services that are run may result in an increase in screening costs.
          Boom&apos;s recommendations based on criteria settings may also change
          based on differences in the template settings
        </p>

        <div className="flex gap-2 w-full">
          <Button
            size={ButtonSize.BASE}
            variant={ButtonVariant.BASE}
            className="flex-1"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.BASE}
            variant={ButtonVariant.PRIMARY}
            className="flex-1"
            onClick={onContinue}
            loading={isPending}
            disabled={isPending}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
